// src/api/musicians.js
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export async function fetchMusicians({ genre, type, city }) {
  const musiciansRef = collection(db, 'Musiciens');
  let constraints = [];

  // CHANGEMENT PRINCIPAL: Utiliser array-contains pour les genres multiples
  if (genre) constraints.push(where('genres', 'array-contains', genre));
  if (city) constraints.push(where('city', '==', city));

  // Gérer les cas comme Chanteur / Chanteuse
  if (type === 'Chanteur') {
    constraints.push(where('type', 'in', ['Chanteur', 'Chanteuse']));
  } else if (type === 'Danseur') {
    constraints.push(where('type', 'in', ['Danseur', 'Danseuse']));
  } else if (type) {
    constraints.push(where('type', '==', type));
  }

  const q = query(musiciansRef, ...constraints);
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// NOUVELLE FONCTION: Obtenir tous les genres uniques disponibles
export async function fetchAvailableGenres() {
  const musiciansRef = collection(db, 'Musiciens');
  const snapshot = await getDocs(musiciansRef);
  
  const genresSet = new Set();
  snapshot.docs.forEach(doc => {
    const data = doc.data();
    if (data.genres && Array.isArray(data.genres)) {
      data.genres.forEach(genre => genresSet.add(genre));
    }
  });
  
  return Array.from(genresSet).sort();
}